const RANGE = Object.freeze({
  MONTH: 'month',
  TODAY: 'today',
  WEEK: 'week',
});

export default Object.freeze({
  TRANSACTIONS_NUMBER: 10,
  RANGE,
});
